export default __webpack_public_path__ + "static/media/vae3.9466ba20.png";